import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DogTrainerCustomerManager from "@/components/DogTrainerCustomerManager";
import PublicIntakePage from "@/components/PublicIntakePage";
import NotFoundPage from "@/components/NotFoundPage";
import LandingPage from "@/components/LandingPage";
import LoginPage from "@/components/auth/LoginPage";
import DemoLandingPage from "@/components/DemoLandingPage";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/auth/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public — marketing landing */}
            <Route path="/" element={<LandingPage />} />
            {/* Public — owner intake */}
            <Route path="/intake" element={<PublicIntakePage />} />
            {/* Public — login screen */}
            <Route path="/login" element={<LoginPage />} />
            {/* Public — live demo launcher (auto-logs in to sandbox) */}
            <Route path="/demo" element={<DemoLandingPage />} />
            {/* Authenticated dashboard */}
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <DogTrainerCustomerManager />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
